import Popup from 'components/popups/Popup'
import React from 'react'

interface BasicPopupProps extends chat.NotificationActionModal { }

const BasicPopup: React.FC<BasicPopupProps> = ({ title, description }) => {
  return (
    <Popup>
      <div className='popup__title'>
        <div>{title}</div>
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </Popup>
  )
}

export default BasicPopup